const CORNER_STYLES = {
  tl: { position: 'absolute', top: '20px', left: '20px', width: '100px', height: '100px', pointerEvents: 'none' },
  tr: { position: 'absolute', top: '20px', right: '20px', width: '100px', height: '100px', pointerEvents: 'none' },
  bl: { position: 'absolute', bottom: '20px', left: '20px', width: '100px', height: '100px', pointerEvents: 'none' },
  br: { position: 'absolute', bottom: '20px', right: '20px', width: '100px', height: '100px', pointerEvents: 'none' },
}

const CORNER_TRANSFORMS = {
  tl: null,
  tr: 'translate(80,0) scale(-1,1)',
  bl: 'translate(0,80) scale(1,-1)',
  br: 'translate(80,80) scale(-1,-1)',
}

function OrnamentPaths() {
  return (
    <>
      <path d="M70 5 L32 5 Q5 5 5 32 L5 70" stroke="rgba(229,168,32,.40)" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M64 12 L34 12 Q12 12 12 34 L12 64"
        stroke="rgba(229,168,32,.14)"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeDasharray="4 4"
      />
      <circle cx="5" cy="5" r="3.5" stroke="rgba(229,168,32,.42)" strokeWidth="1.2" fill="rgba(229,168,32,.08)" />
      <circle cx="5" cy="5" r="1.5" fill="rgba(229,168,32,.7)" />
      <circle cx="70" cy="5" r="1.8" fill="rgba(229,168,32,.32)" />
      <circle cx="5" cy="70" r="1.8" fill="rgba(229,168,32,.32)" />
      <circle cx="40" cy="5" r="1.1" fill="rgba(229,168,32,.20)" />
      <circle cx="56" cy="5" r="0.8" fill="rgba(229,168,32,.13)" />
      <circle cx="5" cy="40" r="1.1" fill="rgba(229,168,32,.20)" />
      <circle cx="5" cy="56" r="0.8" fill="rgba(229,168,32,.13)" />
      <path
        d="M30 56 C19 54,13 46,14 36 C15 25,22 17,33 14 C44 11,56 17,58 29 C60 41,54 53,43 57 C36 60,31 58,30 56Z"
        stroke="rgba(229,168,32,.32)"
        strokeWidth="1.2"
        fill="rgba(229,168,32,.04)"
      />
      <path d="M28 52 C20 49,18 41,20 33 C22 24,29 18,37 18 C45 18,52 24,52 32" stroke="rgba(229,168,32,.18)" strokeWidth="0.75" fill="none" />
      <path
        d="M14 36 C10 27,12 17,18 12 C24 7,32 9,31 15"
        stroke="rgba(229,168,32,.36)"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M18 12 C14 8,14 4,18 4 C22 4,24 8,22 12"
        stroke="rgba(229,168,32,.28)"
        strokeWidth="0.75"
        strokeLinecap="round"
        fill="none"
      />
      <ellipse
        cx="34"
        cy="32"
        rx="4.5"
        ry="5.5"
        transform="rotate(-20 34 32)"
        stroke="rgba(229,168,32,.25)"
        strokeWidth="0.7"
        fill="rgba(229,168,32,.05)"
      />
      <circle cx="34" cy="32" r="1.4" fill="rgba(229,168,32,.45)" />
      <path d="M28 56 C23 63,16 64,14 60" stroke="rgba(229,168,32,.25)" strokeWidth="0.75" strokeLinecap="round" fill="none" />
      <path d="M36 58 C32 65,25 66,23 62" stroke="rgba(229,168,32,.16)" strokeWidth="0.65" strokeLinecap="round" fill="none" />
      <path d="M58 25 C65 19,68 12,64 8" stroke="rgba(229,168,32,.25)" strokeWidth="0.75" strokeLinecap="round" fill="none" />
      <path d="M59 36 C67 31,71 23,67 18" stroke="rgba(229,168,32,.16)" strokeWidth="0.65" strokeLinecap="round" fill="none" />
      <circle cx="16" cy="52" r="1.1" fill="rgba(229,168,32,.20)" />
      <circle cx="52" cy="14" r="1.1" fill="rgba(229,168,32,.20)" />
      <circle cx="58" cy="46" r="0.8" fill="rgba(229,168,32,.13)" />
      <circle cx="13" cy="23" r="0.8" fill="rgba(229,168,32,.13)" />
      <path d="M18 12 C13 9,8 6,5 5" stroke="rgba(229,168,32,.09)" strokeWidth="0.5" fill="none" />
      <path d="M14 36 C10 33,7 26,5 20" stroke="rgba(229,168,32,.07)" strokeWidth="0.5" fill="none" />
    </>
  )
}

export default function KolkaOrnament({ corner }) {
  const transform = CORNER_TRANSFORMS[corner]
  return (
    <div style={CORNER_STYLES[corner]}>
      <svg width="100" height="100" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        {transform ? (
          <g transform={transform}>
            <OrnamentPaths />
          </g>
        ) : (
          <OrnamentPaths />
        )}
      </svg>
    </div>
  )
}
